'use client';

import { ComponentProps } from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

/**
 * Root container for collapsible content, based on Radix UI's Collapsible primitive.
 */
export function Collapsible({
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

/**
 * The element that toggles the visibility of the collapsible content.
 */
export function CollapsibleTrigger({
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    />
  );
}

/**
 * The content that is shown or hidden when the collapsible is toggled.
 */
export function CollapsibleContent({
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      {...props}
    />
  );
}
